import { render, staticRenderFns } from "./CustomFieldsDraggableItem.vue?vue&type=template&id=3b82b218&"
import script from "./CustomFieldsDraggableItem.vue?vue&type=script&lang=js&"
export * from "./CustomFieldsDraggableItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports